<template>
  <div class="videoHot-box">
    <!--数据表格-->
    <el-table
      height="630"
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @sort-change="handleSortChange"
    >
      <el-table-column prop="id" label="ID" align="center"></el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        align="center"
      ></el-table-column>
      <el-table-column prop="cover" label="封面" align="center">
        <template slot-scope="scope">
          <img-load
            :width="'70px'"
            :height="'90px'"
            :src="imgUrl + scope.row.cover"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column
        prop="sortKey"
        label="排序"
        align="center"
        :sortable="'custom'"
      ></el-table-column>
      <el-table-column prop="sortKey" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.enable" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            class="el-icon-edit"
            @click="edit(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      :page-sizes="[5, 10, 15, 20]"
      :current-page="hotListParam.pageNumber"
      :page-size="hotListParam.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 6"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--新增、编辑tag弹窗-->
    <edit-popup ref="editPopup" @handlerEdit="handlerEdit"></edit-popup>
  </div>
</template>
<script>
import EditPopup from "./components/editPopup";
import API from "@/api";
import { sortEscape } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      imgUrl: baseConfig.imgUrl,
      // 51乱伦最热列表请求参数
      hotListParam: {
        pageNumber: 1,
        pageSize: 6,
        key: "",
        value: "",
      },
    };
  },
  components: {
    EditPopup,
  },
  created() {
    this.getVideoHotList(this.hotListParam);
  },
  methods: {
    // 编辑最热
    edit(data) {
      this.$refs.editPopup.open(data);
    },
    // 监听编辑成功过后的回掉
    handlerEdit() {
      this.getVideoHotList(this.hotListParam);
    },
    // 请求短视频最热模块配置列表
    getVideoHotList(params) {
      this.loading = true;
      API.getVideoHotList(params)
        .then((res) => {
          this.loading = false;
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.hotListParam.value = sortEscape(column.order);
        this.hotListParam.key = column.prop;
      } else {
        this.hotListParam.value = "";
        this.hotListParam.key = "";
      }
      this.getVideoHotList(this.hotListParam);
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.hotListParam.pageSize = size;
      this.hotListParam.pageNumber = 1;
      this.getVideoHotList(this.hotListParam);
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.hotListParam.pageNumber = pageNumber;
      this.getVideoHotList(this.hotListParam);
    },
  },
};
</script>
